import { OverlayDrawer } from '@fluentui/react-components';

import { AI_ASSISTANT_OVERLAY_WIDTH_PX } from '../constants';
import { TAiAssistantOrigin } from '../types';
import { requestAiAssistantClose } from '../stores/useAiAssistantStore';
import AiAssistant from './AiAssistant';

type TProps = {
  isOpen: boolean;
  onClose: () => void;
  origin?: TAiAssistantOrigin;
};

const AiAssistantOverlay = ({ isOpen, onClose, origin }: TProps) => (
  <OverlayDrawer
    open={isOpen}
    onOpenChange={(_, data) => {
      if (!data.open) requestAiAssistantClose('overlay', onClose);
    }}
    modalType="non-modal"
    position="end"
    className="!bg-neutralBg-3"
    style={{ width: `${AI_ASSISTANT_OVERLAY_WIDTH_PX}px` }}
  >
    <AiAssistant surface="overlay" onClose={onClose} origin={origin} />
  </OverlayDrawer>
);

export default AiAssistantOverlay;
